import { useQuery } from "@tanstack/react-query";
import { useAuth, authorizedAxios } from "@moonscape/shared";
import { LifecycleStage, DashboardOverlay } from "../types/types";

interface UserStateMetrics {
  txCount: number;
  chainCount: number;
  exchangeCount: number;
  hasTaxSettings: boolean;
  brokenConnections: number;
  bridgePairsUnmatched: number;
  auditFlags: number;
  daysToDeadline: number | null;
  pricedPct: number;
  freeTxnUsed: number;
  freeTxnLimit: number;
  planSlug: string;
  planTxnLimit: number | null;
  nextPlanSlug: string | null;
  nextPlanName: string | null;
  isOverPlanLimit: boolean;
  isGrandfathered: boolean;
  hasExchanges: boolean;
  isSyncing: boolean;
  hasCsvOnly: boolean;
}

interface UserStateResponse {
  stage: LifecycleStage;
  overlays: DashboardOverlay[];
  metrics: UserStateMetrics;
  isPremium: boolean;
}

export const useUserStateQueryKey = ["userState"];

export const useUserState = () => {
  const { user, getToken } = useAuth();

  const fetchUserState = async (): Promise<UserStateResponse> => {
    const token = await getToken();
    const res = await authorizedAxios(token).get("/user/state");
    return res.data;
  };

  return useQuery({
    queryKey: useUserStateQueryKey,
    queryFn: fetchUserState,
    enabled: !!user,
    staleTime: 30 * 1000, // 30 seconds - matches server cache TTL
    refetchInterval: 30 * 1000,
  });
};
